import {
  validateLabel,
  validateStartTime,
  validateEndTime,
  validateDescription,
  validatePrimaryColor,
  validateSecondaryColor,
  validateEmoji,
} from "#shared/inputValidation/inputValidation.js";
import {
  checkIfValidJSON,
  checkIfIsAnArray,
} from "#root/shared/stringConditionals.js";

export const validatePastedJSON = (pastedJSON: string) => {
  const returnValue: { errorClass: string; errorMessages: string[] } = {
    errorClass: "default",
    errorMessages: [],
  };
  if (pastedJSON === "") {
    returnValue.errorClass = "default";
    returnValue.errorMessages = [""];
    return returnValue;
  } else if (!checkIfValidJSON(pastedJSON)) {
    returnValue.errorClass = "invalid";
    returnValue.errorMessages.push("Input is not in valid JSON format");
    return returnValue;
  } else if (!checkIfIsAnArray(pastedJSON)) {
    returnValue.errorClass = "invalid";
    returnValue.errorMessages.push(
      "Input must be contained within square brackets",
    );
  } else {
    const parsedJSON = JSON.parse(pastedJSON);
    for (let index = 0; index < parsedJSON.length; index++) {
      const currentInterval = parsedJSON[index];
      if (currentInterval.label === undefined) {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": Keyname 'label' is missing",
        );
      } else {
        const labelValid = validateLabel(currentInterval.label);
        if (labelValid.errorClass === "invalid") {
          returnValue.errorClass = "invalid";
          returnValue.errorMessages.push(
            "Interval " + (index + 1) + ": " + labelValid.errorMessages[0],
          );
        }
      }
      if (currentInterval.startTime === undefined) {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": Keyname 'startTime' is missing",
        );
      } else if (currentInterval.endTime === undefined) {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": Keyname 'endTime' is missing",
        );
      } else {
        const startTimeValid = validateStartTime([
          currentInterval.startTime,
          currentInterval.endTime,
        ]);
        if (startTimeValid.errorClass === "invalid") {
          returnValue.errorClass = "invalid";
          returnValue.errorMessages.push(
            "Interval " + (index + 1) + ": " + startTimeValid.errorMessages[0],
          );
        }
        const endTimeValid = validateEndTime([
          currentInterval.startTime,
          currentInterval.endTime,
        ]);
        if (endTimeValid.errorClass === "invalid") {
          returnValue.errorClass = "invalid";
          returnValue.errorMessages.push(
            "Interval " + (index + 1) + ": " + endTimeValid.errorMessages[0],
          );
        }
      }
      const descriptionValid = validateDescription(currentInterval.description);
      if (descriptionValid.errorClass === "invalid") {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": " + descriptionValid.errorMessages[0],
        );
      }
      const emojiValid = validateEmoji(currentInterval.emoji);
      if (emojiValid.errorClass === "invalid") {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": " + emojiValid.errorMessages[0],
        );
      }
      if (currentInterval.primaryColor === undefined) {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": Keyname 'primaryColor' is missing",
        );
      } else {
        const primaryColorValid = validatePrimaryColor(
          currentInterval.primaryColor,
        );
        if (primaryColorValid.errorClass === "invalid") {
          returnValue.errorClass = "invalid";
          returnValue.errorMessages.push(
            "Interval " +
              (index + 1) +
              ": " +
              primaryColorValid.errorMessages[0],
          );
        }
      }
      if (currentInterval.secondaryColor === undefined) {
        returnValue.errorClass = "invalid";
        returnValue.errorMessages.push(
          "Interval " + (index + 1) + ": Keyname 'secondaryColor' is missing",
        );
      } else {
        const secondaryColorValid = validateSecondaryColor(
          currentInterval.secondaryColor,
        );
        if (secondaryColorValid.errorClass === "invalid") {
          returnValue.errorClass = "invalid";
          returnValue.errorMessages.push(
            "Interval " +
              (index + 1) +
              ": " +
              secondaryColorValid.errorMessages[0],
          );
        }
      }
    }
    if (returnValue.errorMessages.length === 0) {
      returnValue.errorClass = "valid";
    }
  }
  return returnValue;
};
